/**
 * API 列表
 */
const config = {
  loginPage: '/login',
  appId: 'fosber', //配置APPID
  // server: "http://wx.chancentech.com/"
  server:"/"
  // server: process.env.NODE_ENV === 'production' ? "/":"http://devadmin2.nowbook.sup.services/"
}

const apiList = {

  //系统模块
  sys: {
    admin_login: 'loginJson',
    admin_login_check: "validate",
    search_user: "mgr/search",
    anonymousUserSwitchSave: "admin/user/anonymousUserSwitch/save",
    anonymousUserSwitchGet: "admin/user/anonymousUserSwitch/get"


  },

  //用户模块的API
  user: {
    query: "admin/user/query",
    permission: "getUserPermissions",
    update: "admin/user/updateUserInfo",
    create_vip: "admin/user/superMemberApplication/create",
    vip_list: "admin/user/superMemberApplication/query",
    delete: "admin/user/superMemberApplication/delete",
    audit: "admin/user/superMemberApplication/audit"
  },
  // 产品模块的API
  product: {
    get: "/admin/fsb/product/get",
    query: "/admin/fsb/product/query",
    save: "/admin/fsb/product/save",
    delete: "/admin/fsb/product/delete",
  },

  //微信公众号模块
  wechat: {
    query: "wechat/mp/wxMpMessage/query"
  }
}

export default {
  config,
  apiList
}
